import React, { useState, useEffect } from "react";


const notificationLevel = {
  error: {
    className: "is-warning",
    label: "Error",
  },
  success: {
    className: "is-success",
    label: "Éxito",
  },
};


const Notification = (props) => {
  const [hidden, setHidden] = useState(true);

  useEffect(() => {
    setHidden(!props.message);
  }, [props.message]);

  if (hidden) {
    return null;
  }

  const { className, label } = notificationLevel[props.level];

  return (
    <div className={`notification ${className}`}>
      <button className="delete" onClick={() => setHidden(true)}></button>
      <b>{label}.</b> {props.message}
    </div>
  );
};


Notification.defaultProps = {
  level: "error"
};


export default Notification;